import { BaseForm } from './baseForm';
import { MatDialog } from '@angular/material/dialog';
import { ImageUploadHandlerService } from '../services/image-upload-handler.service';
import { ImageService } from '../../dashboard/seller/payment-pages/services/image.service';
import { CongratulationComponent } from '../components/congratulation/congratulation.component';
import { FIELDS } from './fields';
import { EdittedSuccessfullyComponent } from '../components/editted-successfully/editted-successfully.component';
import { AbstractControl } from '@angular/forms';
import { FormValidatorService } from '../services/form-validator.service';

export abstract class BaseProduct {
  currentStep: number = 1;
  canGoToBuyerInfoStep!: boolean;
  productName: string = '';
  private _forms!: BaseForm[];

  constructor(private imageUpload: ImageUploadHandlerService,
    private imageUploadRqst: ImageService,
    private dialog: MatDialog ) { }

  set forms(forms: BaseForm[]) {
    this._forms = forms
  }

  get StepsValue() {
    let values: any;
    if (this._forms) {
      this._forms.forEach((form) => {
        if (form.fromValue) {
          values = { ...values, ...form.fromValue }
        }
      })
      return values;
    }
  }

  isLastStep(): any {
    if (this._forms) {
      return this.currentStep == this._forms.length
    }
  }

  isCurrentStepValid() {
    if (this._forms) {

      let form = this._forms[this.currentStep - 1]
      if (!form.fromValue || form.from.invalid) {
        return false;
      }

      return true;
    }
    else {
      return false;
    }
  }

  async nextStep() {
    if (this._forms[this.currentStep - 1].fromValue) {
      this.currentStep++;

    }
  }

  prevStep() {
    this.currentStep--;
  }

  async uploadImage(image: any) {
    this.imageUpload.setUploaderService(this.imageUploadRqst)
    await this.imageUpload.setImageFile(image)
    return await this.imageUpload.upload()
  }

  openCongratulationDialoug(url: any, productName: any, productTypeName: any, editMode: boolean = false) {
    if (editMode) {
      this.dialog.open(EdittedSuccessfullyComponent, {
        panelClass: "responsive-dialog",
        data: {
          url: url,
          name: productName,
          type: productTypeName
        }
      });
    } else {
       this.dialog.open(CongratulationComponent, {
        panelClass: "responsive-dialog",
        data: {
          url: url,
          name: productName,
          type: productTypeName,
          showCongratulation: true
        }
      });
    }
  }

  getBuyerInfoTogglerChoice() {
    const allParsedSteps: any = this.StepsValue;
    console.log("allParsedSteps: ", allParsedSteps);
    const choice = allParsedSteps[FIELDS.STEPS.BUYER_INFO_TOGGLER];
    if (typeof choice !== 'undefined') {
      this.canGoToBuyerInfoStep = choice;
    }
  }


  qasatlyDepositValidation(
    stepOneFromControll:AbstractControl,
    stepOneFormValidator:FormValidatorService,
    itemPrice:number,
    depositAmount:number):Boolean{
      if(depositAmount > 0){
        if(depositAmount>itemPrice){
          stepOneFromControll.setErrors({
            max:itemPrice
          })
          stepOneFormValidator.addError('Do you want Qasatly Deposit?','max',`Cannot be more than The Product price ${itemPrice}`,`لا يمكن ان يكون اكثر من ثمن منتج ${itemPrice}`);
          stepOneFormValidator.forceShowErrors();
          return true;
        }
        return false;
      }else return false;
  }
  isStepBeforeBuyerInfoStep(): any {
    switch (this.productName) {
      case 'Physical Product':
        if (this.currentStep === 2) {
          return true;
        }
        break;
      case 'Invoice':
        if (this.currentStep === 2) {
          return true;
        }
        break;
      case 'Collection':
        if (this.currentStep === 2) {
          return true;
        }
        break;
      case 'Subscription Product':
        if (this.currentStep === 2) {
          return true;
        }
        break;

      case 'Event':
        if (this.currentStep === 3) {
          return true;
        }
        break;
      case 'Calendar':
        if (this.currentStep === 2) {
          return true;
        }
        break;
      case 'QuickPayment':
        if (this.currentStep === 1) {
          return true;
        }
        break;
      case 'Reservation':
        if(this.currentStep==2) return true;
        break;
      default:
        return false;
        break;
    }
  }
}
